import React from "react";
import { AnimatedOpacityViewView } from "./view";
import { styles } from "./styles";

export class AnimatedOpacityView extends React.Component {
  render() {
    return <AnimatedOpacityViewView {...this.props} styles={styles} />;
  }
}
